import { BaseButtons, BaseForm, BaseTextInput, useControllerSeServe, useInputGenerico, useRichiestaServer } from '@lucan/base-ui';
import datiListCompleta from 'configuration/list.json';
import React, { useEffect, useState } from "react"
import {
  Box,
  Checkbox,
  FormControlLabel,
  List,
  ListItemButton,
  ListItemText,
  TextField,
  Typography
} from "@mui/material"
import { OPERAZIONI } from 'configuration/ConfigurazioneApi';
import { useAppContext } from 'GlobalContext';
import { DatePicker } from '@mui/lab';
import Configurazioni from './Configurazioni';

export default function ConfigurazioniNuova() {

  const [cmd, setcmd] = useState(null)
  
  function confermaComando(valoriForm) {
    setcmd(valoriForm.comando)
  }

  return (
    <Box display="flex" height="100%">
      <BaseForm
        onSubmit={confermaComando}
      >
        <BaseTextInput
          label="Comando"
          name='comando'
          required
        />
        <br />
        <BaseButtons.Custom
          testo="applica"
          submit
          sx={{ mt: 2 }}
        />
      
      </BaseForm>
      {cmd && <Configurazioni cmd={cmd}/>}

    </Box>
  )
}

 function toInputString(value) {
  if (value === undefined || value === null) return ""
  if (typeof value === "string") return value
  return JSON.stringify(value, null, 2)
}

function parseInput(value) {
  if (value === "") return ""

  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

function JsonTextField(props) {

const {
  label,
  posizioneLabel = 'sopra',
    ...restProps
  } = props
const mappaLabelPlacement = {
  sopra: 'top',
  sotto: 'bottom',
  destra: 'end',
  sinistra: 'start'
}
  const inputGenericoProps = useInputGenerico({
    componenteControllato: true,
    widthType: 'width',
    ...restProps
  })
  const {
    value,
    onBlur,
    onChange,
    ref,
    propsRimanenti
  } = useControllerSeServe(inputGenericoProps)

  function getInputComponent(tipo) {
    const map = {
      string: TextField,
      number: TextField,
      boolean: Checkbox,
      date: DatePicker,
      object: TextField, // multiline + JSON
      array: TextField,  // multiline + JSON
      null: TextField,
      undefined: TextField,
    };
    return map[tipo] || TextField;
  }
  function detectType(value) {
    if (value === null || value === undefined) return "null";
    if (typeof value === "string") return "string";
    if (typeof value === "number") return "number";
    if (typeof value === "boolean") return "boolean";
    if (value instanceof Date) return "date";
    if (Array.isArray(value)) return "array";
    if (typeof value === "object") return "object";
    return "string";
  }
    const tipo = detectType(value);

  const InputElement = (() => {
    switch (tipo) {
      case "boolean":
        return (
          <Checkbox
            checked={value || false}
            onChange={(e) => onChange(parseInput(e.target.checked))}
            onBlur={onBlur}
            /*{...propsRimanenti}  <- da problemi sull'onchange*/
          />
        );

      case "date":
        return (
          <DatePicker
            value={value || null}
            onChange={onChange}
            renderInput={(params) => <TextField {...params} {...propsRimanenti} />}
          />
        );

      case "object":
      case "array":
        return (
          <TextField
            multiline
            minRows={3}
            maxRows={10}
            value={toInputString(value)}
            onChange={(e) => onChange(parseInput(e.target.value))}
            onBlur={onBlur}
            {...propsRimanenti}
          />
        );

      case "number":
        return (
          <TextField
            type="number"
            value={toInputString(value)}
            onChange={(e) => onChange(parseInput(e.target.value))}
            onBlur={onBlur}
            {...propsRimanenti}
          />
        );

      case "string":
      case "null":
      default:
        return (
          <TextField
            value={toInputString(value)}
            onChange={(e) => onChange(parseInput(e.target.value))}
            onBlur={onBlur}
            {...propsRimanenti}
          />
        );
    }
  })();
  return (
    <FormControlLabel
      label={label}
      labelPlacement={mappaLabelPlacement[posizioneLabel]}
      value={toInputString(value)}
      onBlur={onBlur}
      onChange={e => {
            const raw = e.target.value
            console.log(raw, parseInput(raw), value)
            onChange(parseInput(raw))
          }}
      control={InputElement}
    />
  )
}